<template>
	<el-header
		class="chat-header"
		height="60px"
		:class="[
			electronMode ? 'header-menu-wrap' : '',
			showDivider ? 'with-divider' : 'without-divider',
			mobileMode ? 'mobile-mode' : ''
		]"
	>
		<div class="header-main">
			<button
				v-if="showBack"
				type="button"
				class="nav-back"
				@click="$emit('back')"
			>
				<i class="el-icon-arrow-left"></i>
			</button>
			<div class="header-copy">
				<div class="title-row">
					<div class="title">{{ title }}</div>
				</div>
				<div v-if="subtitle || isDnd" class="subtitle-row">
					<div v-if="subtitle" class="subtitle" :title="subtitle">{{ subtitle }}</div>
					<span v-if="subtitle && isDnd" class="subtitle-separator">·</span>
					<span v-if="isDnd" class="status-text">免打扰</span>
				</div>
			</div>
		</div>
		<div class="action-bar">
			<button
				v-if="isPrivate"
				type="button"
				title="语音通话"
				aria-label="语音通话"
				class="action-btn action-btn--accent"
				@click="$emit('private-video', 'voice')"
			><i class="action-btn__glyph el-icon-phone-outline"></i></button>
			<button
				v-if="isPrivate"
				type="button"
				title="视频通话"
				aria-label="视频通话"
				class="action-btn action-btn--accent"
				@click="$emit('private-video', 'video')"
			><i class="action-btn__glyph el-icon-video-camera"></i></button>
			<button
				type="button"
				title="聊天记录"
				aria-label="聊天记录"
				class="action-btn"
				@click="$emit('show-history')"
			><i class="action-btn__glyph el-icon-chat-dot-round"></i></button>
			<button
				type="button"
				title="会话资料"
				aria-label="会话资料"
				class="btn-side"
				@click="$emit('toggle-side')"
			>
				<i class="action-btn__glyph el-icon-more"></i>
			</button>
		</div>
	</el-header>
</template>

<script>
export default {
	name: "chatHeader",
	props: {
		title: { type: String, default: "" },
		subtitle: { type: String, default: "" },
		isDnd: { type: Boolean, default: false },
		showDivider: { type: Boolean, default: true },
		electronMode: { type: Boolean, default: false },
		isPrivate: { type: Boolean, default: false },
		mobileMode: { type: Boolean, default: false },
		showBack: { type: Boolean, default: false }
	}
}
</script>

<style scoped lang="scss">
.chat-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-shrink: 0;
	padding: 10px var(--chat-header-inline-padding, 12px);
	gap: 12px;
	border-bottom: 0;
	background: transparent;

	&.with-divider {
		border-bottom: var(--im-border);
	}

	&.without-divider {
		padding-bottom: 4px;
	}

	.header-main {
		display: flex;
		align-items: center;
		gap: 12px;
		min-width: 0;
		flex: 1;
	}

	.header-copy {
		min-width: 0;
		flex: 1;
	}

	.nav-back {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: 34px;
		height: 34px;
		padding: 0;
		border: 1px solid var(--im-control-border);
		border-radius: 9px;
		background: var(--im-control-bg);
		color: var(--im-icon-color-strong);
		cursor: pointer;
		transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

		i {
			font-size: 15px;
		}

		&:hover {
			background: var(--im-icon-hover-bg);
			border-color: rgba(var(--im-primary-rgb), 0.18);
			color: var(--im-icon-hover-color);
			box-shadow: 0 0 0 1px rgba(var(--im-primary-rgb), 0.05);
		}

		&:active {
			background: var(--im-icon-active-bg);
		}
	}

	.title-row {
		display: flex;
		align-items: center;
		min-width: 0;
	}

	.title {
		font-size: 18px;
		font-weight: 700;
		color: var(--im-text-color);
		line-height: 1.2;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.subtitle-row {
		display: flex;
		align-items: center;
		gap: 7px;
		min-width: 0;
		margin-top: 3px;
	}

	.subtitle {
		min-width: 0;
		font-size: 12px;
		color: var(--im-text-color-secondary);
		line-height: 1.35;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.subtitle-separator,
	.status-text {
		flex-shrink: 0;
		font-size: 12px;
		line-height: 1.3;
	}

	.subtitle-separator {
		color: var(--im-text-color-light);
	}

	.status-text {
		display: inline-flex;
		align-items: center;
		height: 20px;
		padding: 0 7px;
		border-radius: 999px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 11px;
		font-weight: 600;
	}

	.action-bar {
		display: flex;
		align-items: center;
		gap: 7px;
		flex-shrink: 0;
		padding: 0;
		border-radius: 0;
		background: transparent;
		border: none;
		box-shadow: none;
	}

	.action-btn,
	.btn-side {
		appearance: none;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		height: 36px;
		width: 36px;
		min-width: 36px;
		padding: 0;
		border: 1px solid var(--im-control-border);
		border-radius: 10px;
		background: var(--im-control-bg);
		line-height: 1;
		color: var(--im-icon-color);
		font-size: var(--im-font-size);
		cursor: pointer;
		user-select: none;
		transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			background: var(--im-icon-hover-bg);
			color: var(--im-icon-hover-color);
			border-color: rgba(var(--im-primary-rgb), 0.18);
			box-shadow: 0 0 0 1px rgba(var(--im-primary-rgb), 0.05);
		}

		&:focus,
		&:focus-visible {
			outline: none;
			box-shadow: 0 0 0 2px rgba(var(--im-primary-rgb), 0.12);
		}
	}

	.action-btn__glyph {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		min-width: 16px;
		line-height: 1;
		transform: translateY(0);
	}

	.action-btn--accent {
		color: var(--im-icon-color);
	}

	.btn-side {
		color: var(--im-icon-color);
	}

	&.mobile-mode {
		min-height: 52px;
		height: auto !important;
		padding: 8px 12px;
		background: var(--im-chat-bg);

		.action-bar {
			gap: 6px;
		}

		.action-btn,
		.btn-side {
			width: 34px;
			height: 34px;
			min-width: 34px;
			border-radius: 10px;
		}

		.action-btn__glyph {
			font-size: 15px;
			min-width: 15px;
		}

		.title {
			font-size: 17px;
		}

		.subtitle-row {
			margin-top: 2px;
		}
	}
}
</style>
